import { Box, Typography } from "@mui/material";
import {
  capitalizeWords,
  formatContentTitle,
  formatPageUrl,
  getSelectedBrandName,
  getSubDomain,
} from "@platformx/utilities";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import MenuList from "../menuList/MenuList";
import { useStyles } from "./ContentRow.styles";
import { ContentRowProps } from "./ContentRow.types";

const ContentRow = ({
  item,
  deleteContent,
  duplicate,
  preview,
  unPublish,
  view,
  edit,
  fetchContentDetails,
}: ContentRowProps) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const { ContentType, CurrentPageURL } = item;
  const url = CurrentPageURL?.startsWith("/") ? CurrentPageURL?.substring(1) : CurrentPageURL;
  // function to view published pages
  const handleView = () => {
    const selectedBrandRoute = formatPageUrl(getSelectedBrandName() || i18n.language);
    window.open(
      `${getSubDomain()}/${selectedBrandRoute}/${ContentType?.toLowerCase() === "vod" ? "video" : ContentType?.toLowerCase()}/${url}`,
    );
  };

  return (
    <Box className={classes.contentRowContainer}>
      <Typography
        component='h2'
        variant='h6regular'
        className={classes.contentRowText}
        onClick={handleView}
        data-testid='dashboard-content-row'>
        {capitalizeWords(formatContentTitle(item.Title))}
      </Typography>
      <MenuList
        item={item}
        deleteContent={deleteContent}
        duplicate={duplicate}
        preview={preview}
        unPublish={unPublish}
        view={view}
        edit={edit}
        fetchContentDetails={fetchContentDetails}
      />
    </Box>
  );
};

export default memo(ContentRow);
